export const categories = [
  { slug: "romance", name: "恋爱言情", icon: "ri-heart-line", desc: "甜蜜浪漫的韩漫恋爱故事" },
  { slug: "fantasy", name: "奇幻冒险", icon: "ri-magic-line", desc: "充满想象力的奇幻世界" },
  { slug: "action", name: "热血动作", icon: "ri-sword-line", desc: "刺激热血的战斗场面" },
  { slug: "comedy", name: "搞笑日常", icon: "ri-emotion-laugh-line", desc: "轻松搞笑的日常喜剧" },
  { slug: "thriller", name: "悬疑惊悚", icon: "ri-ghost-line", desc: "扣人心弦的悬疑故事" },
  { slug: "drama", name: "剧情深度", icon: "ri-quill-pen-line", desc: "深刻动人的剧情作品" },
  { slug: "school", name: "校园青春", icon: "ri-building-line", desc: "青春校园的成长故事" },
  { slug: "historical", name: "古风历史", icon: "ri-ancient-gate-line", desc: "穿越时空的历史画卷" },
];

export const featuredManhwa = [
  {
    id: 1,
    title: "重生之都市修仙",
    author: "飞天鱼",
    category: "fantasy",
    rating: 9.5,
    views: "1280万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20digital%20art%20illustration%20of%20a%20handsome%20young%20man%20in%20modern%20urban%20setting%20with%20magical%20energy%20surrounding%20him%2C%20clean%20composition%2C%20vibrant%20warm%20colors%2C%20dramatic%20lighting%2C%20vertical%20poster%20layout%2C%20minimal%20background%20with%20soft%20bokeh%20effect&width=400&height=560&seq=manhwa-cover-01&orientation=portrait",
    desc: "普通上班族意外重生，带着前世记忆在都市中踏上修仙之路",
    tags: ["重生", "修仙", "都市"],
  },
  {
    id: 2,
    title: "她的秘密花园",
    author: "樱花兔子",
    category: "romance",
    rating: 9.3,
    views: "960万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20style%20digital%20art%20of%20a%20beautiful%20woman%20standing%20in%20a%20flower%20garden%20with%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20cherry%20blossom%20petals%20floating%2C%20warm%20sunlight%2C%20vertical%20poster%20composition%2C%20clean%20simple%20background&width=400&height=560&seq=manhwa-cover-02&orientation=portrait",
    desc: "继承了祖母的秘密花园后，她发现了隐藏百年的浪漫往事",
    tags: ["浪漫", "悬疑", "治愈"],
  },
  {
    id: 3,
    title: "暗影猎手",
    author: "黑瞳",
    category: "action",
    rating: 9.6,
    views: "2150万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20style%20digital%20art%20of%20a%20cool%20warrior%20holding%20a%20weapon%20in%20dark%20alley%2C%20neon%20lighting%2C%20cyberpunk%20aesthetic%2C%20dynamic%20pose%2C%20dramatic%20shadows%2C%20vertical%20poster%20layout%2C%20warm%20accent%20colors&width=400&height=560&seq=manhwa-cover-03&orientation=portrait",
    desc: "在黑暗都市中，一群身怀绝技的猎手与邪恶势力展开殊死搏斗",
    tags: ["动作", "都市", "战斗"],
  },
  {
    id: 4,
    title: "魔法学院优等生",
    author: "星月夜",
    category: "fantasy",
    rating: 9.4,
    views: "1560万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20school%20style%20digital%20art%20of%20a%20young%20student%20with%20magic%20spell%20effects%20in%20a%20grand%20academy%20hall%2C%20warm%20magical%20glow%2C%20elegant%20uniform%2C%20vertical%20poster%2C%20clean%20composition%2C%20soft%20warm%20lighting&width=400&height=560&seq=manhwa-cover-04&orientation=portrait",
    desc: "平凡少年进入魔法学院，凭借勤奋与天赋成为最耀眼的优等生",
    tags: ["魔法", "学院", "成长"],
  },
  {
    id: 5,
    title: "社长大人请自重",
    author: "棉花糖",
    category: "comedy",
    rating: 9.2,
    views: "890万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20office%20style%20digital%20art%20of%20a%20funny%20couple%20in%20office%20setting%20with%20exaggerated%20expressions%2C%20bright%20warm%20colors%2C%20playful%20atmosphere%2C%20vertical%20poster%20composition%2C%20clean%20simple%20background&width=400&height=560&seq=manhwa-cover-05&orientation=portrait",
    desc: "霸道社长与天然呆员工的办公室日常搞笑喜剧",
    tags: ["搞笑", "职场", "恋爱"],
  },
  {
    id: 6,
    title: "第九层地狱",
    author: "暗夜行者",
    category: "thriller",
    rating: 9.7,
    views: "1890万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20style%20digital%20art%20of%20a%20mysterious%20figure%20in%20shadows%20with%20red%20ominous%20lighting%2C%20dark%20atmosphere%2C%20suspenseful%20mood%2C%20vertical%20poster%20layout%2C%20dramatic%20composition%2C%20warm%20dark%20tones&width=400&height=560&seq=manhwa-cover-06&orientation=portrait",
    desc: "一栋神秘大楼，每层都隐藏着令人窒息的恐怖秘密",
    tags: ["悬疑", "恐怖", "推理"],
  },
  {
    id: 7,
    title: "时光里的我们",
    author: "夏日晚风",
    category: "drama",
    rating: 9.5,
    views: "1120万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20style%20digital%20art%20of%20two%20people%20looking%20at%20sunset%20from%20a%20rooftop%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20hour%20lighting%2C%20emotional%20vibe%2C%20vertical%20poster%20composition%2C%20clean%20simple%20background&width=400&height=560&seq=manhwa-cover-07&orientation=portrait",
    desc: "十年后再相遇，那些错过的时光能否重新拾起",
    tags: ["剧情", "怀旧", "情感"],
  },
  {
    id: 8,
    title: "剑道至尊",
    author: "铁剑无双",
    category: "action",
    rating: 9.3,
    views: "1430万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20style%20digital%20art%20of%20a%20swordsman%20in%20traditional%20clothing%20on%20mountain%20peak%2C%20epic%20composition%2C%20dramatic%20clouds%2C%20warm%20sunset%20lighting%2C%20vertical%20poster%2C%20clean%20heroic%20pose&width=400&height=560&seq=manhwa-cover-08&orientation=portrait",
    desc: "少年剑客从草根崛起，以无上剑道问鼎天下至尊之位",
    tags: ["武侠", "热血", "成长"],
  },
];

export const latestArticles = [
  {
    id: 1,
    title: "2026年最值得期待的十部韩国漫画新作推荐",
    excerpt: "新的一年，韩国漫画界又迎来了众多令人期待的新作。从奇幻冒险到都市爱情，我们精选了十部即将上线或刚刚开更的韩漫，每一部都有成为爆款的潜力。",
    category: "recommendation",
    categoryName: "推荐榜单",
    author: "漫画编辑小陈",
    date: "2026-07-28",
    readTime: "8分钟",
    thumbnail: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20collection%20display%20with%20multiple%20colorful%20comic%20covers%20arranged%20artistically%2C%20warm%20ambient%20lighting%2C%20cozy%20reading%20atmosphere%2C%20clean%20composition%2C%20editorial%20style%20photography&width=800&height=450&seq=article-thumb-01&orientation=landscape",
    tags: ["新作推荐", "2026"],
  },
  {
    id: 2,
    title: "深度解析：韩漫为何能在全球掀起阅读热潮",
    excerpt: "从韩流音乐到韩剧，再到如今的韩国漫画，韩流文化的影响力正在持续扩大。本文将深入探讨韩漫成功的背后原因，以及它在全球漫画产业中的独特定位。",
    category: "analysis",
    categoryName: "深度分析",
    author: "文化产业观察员",
    date: "2026-07-25",
    readTime: "12分钟",
    thumbnail: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20culture%20global%20trend%20illustration%20with%20world%20map%20and%20comic%20elements%2C%20warm%20modern%20design%2C%20editorial%20style%2C%20clean%20composition&width=800&height=450&seq=article-thumb-02&orientation=landscape",
    tags: ["产业分析", "韩流"],
  },
  {
    id: 3,
    title: "从入门到精通：韩漫阅读平台完全指南",
    excerpt: "面对众多的韩漫阅读平台，新手往往会感到困惑。本文整理了目前主流的韩漫在线阅读渠道，包括官方平台和资源导航站点，助你轻松找到心仪的作品。",
    category: "guide",
    categoryName: "阅读指南",
    author: "资深漫迷老王",
    date: "2026-07-22",
    readTime: "10分钟",
    thumbnail: "https://readdy.ai/api/search-image?query=Digital%20manhwa%20reading%20platform%20on%20tablet%20and%20phone%20screens%2C%20modern%20cozy%20setting%2C%20warm%20lighting%2C%20clean%20composition%2C%20editorial%20style%20photography&width=800&height=450&seq=article-thumb-03&orientation=landscape",
    tags: ["平台指南", "新手入门"],
  },
  {
    id: 4,
    title: "奇幻类韩漫TOP20：构建最宏大的异世界",
    excerpt: "奇幻题材一直是韩国漫画的强势品类。从剑与魔法到东方玄幻，优秀的奇幻韩漫总能带给读者无与伦比的沉浸感。来看看这些构建了惊人世界观的佳作。",
    category: "recommendation",
    categoryName: "推荐榜单",
    author: "漫画编辑小陈",
    date: "2026-07-20",
    readTime: "15分钟",
    thumbnail: "https://readdy.ai/api/search-image?query=Fantasy%20world%20illustration%20with%20magical%20landscape%20castles%20and%20creatures%20in%20Korean%20manhwa%20art%20style%2C%20warm%20epic%20atmosphere%2C%20dramatic%20lighting%2C%20editorial%20composition&width=800&height=450&seq=article-thumb-04&orientation=landscape",
    tags: ["奇幻", "榜单"],
  },
  {
    id: 5,
    title: "韩漫改编韩剧大盘点：这些漫画原著比剧还精彩",
    excerpt: "许多热门韩剧其实都改编自韩国漫画。然而，漫画原著往往有着更丰富的细节和不同的故事走向。来看看那些比改编剧还要精彩的韩漫原著。",
    category: "analysis",
    categoryName: "深度分析",
    author: "韩剧漫画双修者",
    date: "2026-07-18",
    readTime: "9分钟",
    thumbnail: "https://readdy.ai/api/search-image?query=Korean%20drama%20and%20manhwa%20crossover%20comparison%20display%2C%20split%20screen%20showing%20comic%20and%20live%20action%20side%20by%20side%2C%20warm%20cinematic%20lighting%2C%20editorial%20style&width=800&height=450&seq=article-thumb-05&orientation=landscape",
    tags: ["改编", "韩剧"],
  },
  {
    id: 6,
    title: "恋爱类韩漫推荐：让心跳加速的甜蜜故事",
    excerpt: "恋爱漫画是韩漫中受众最广的类型之一。无论是青涩的校园初恋，还是成熟的都市爱情，这些作品都能让人感受到爱情的美好与温暖。",
    category: "recommendation",
    categoryName: "推荐榜单",
    author: "漫画编辑小陈",
    date: "2026-07-15",
    readTime: "7分钟",
    thumbnail: "https://readdy.ai/api/search-image?query=Romantic%20Korean%20manhwa%20style%20illustration%20with%20couple%20in%20cherry%20blossom%20scene%2C%20soft%20pink%20warm%20tones%2C%20dreamy%20atmosphere%2C%20editorial%20composition%2C%20clean%20simple%20background&width=800&height=450&seq=article-thumb-06&orientation=landscape",
    tags: ["恋爱", "推荐"],
  },
];

export const faqData = [
  {
    question: "这个网站提供免费韩漫在线阅读吗？",
    answer: "本网站是韩漫资源导航平台，为您整理和推荐优质的韩漫资源入口。我们汇总了各主流平台的韩漫资源，方便您一站式发现和访问。部分平台提供免费阅读，具体以各平台实际政策为准。",
  },
  {
    question: "如何找到我想看的特定类型韩漫？",
    answer: "您可以通过网站顶部的分类导航，选择恋爱言情、奇幻冒险、热血动作、搞笑日常等不同类型，快速筛选出符合您口味的韩漫作品。每个分类下都有详细的漫画列表和推荐。",
  },
  {
    question: "网站上的漫画推荐多久更新一次？",
    answer: "我们的编辑团队每周会更新热门推荐榜单和新作资讯，确保您能第一时间发现最新、最热门的韩漫作品。建议收藏本站或订阅我们的资讯推送。",
  },
  {
    question: "韩漫和日漫有什么区别？",
    answer: "韩漫（Webtoon）通常采用纵向滚动式阅读方式，画面以全彩为主，更适应手机端阅读习惯。故事题材上，韩漫在都市爱情、职场、奇幻冒险等类型上有独特的表现力。日漫则以黑白为主，多为翻页式阅读。两者各有千秋。",
  },
  {
    question: "网站支持手机端访问吗？",
    answer: "是的，本网站采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您使用什么设备，都能获得流畅舒适的浏览体验。",
  },
  {
    question: "如何获取最新的韩漫更新通知？",
    answer: "您可以在页面底部订阅我们的资讯通讯，我们将定期为您推送最新的韩漫推荐、新作资讯和独家漫评。订阅完全免费，随时可以取消。",
  },
];

export const resourceLinks = [
  { name: "Naver Webtoon", url: "#", desc: "韩国最大的网络漫画平台" },
  { name: "Kakao Webtoon", url: "#", desc: "Kakao旗下漫画阅读平台" },
  { name: "Daum Webtoon", url: "#", desc: "韩国老牌漫画平台" },
  { name: "Lezhin Comics", url: "#", desc: "知名付费韩漫平台" },
  { name: "Tappytoon", url: "#", desc: "英文韩漫翻译平台" },
  { name: "咚漫", url: "#", desc: "中文正版韩漫平台" },
  { name: "PODO", url: "#", desc: "韩国新锐漫画平台" },
  { name: "RIDI", url: "#", desc: "综合性数字内容平台" },
];

export const stats = [
  { value: "5000+", label: "收录漫画" },
  { value: "50万+", label: "月活跃用户" },
  { value: "98%", label: "好评率" },
  { value: "8个", label: "精选分类" },
];